import {
  setItemLocalStorage,
  getItemLocalStorage,
  AUTOKEY_TYPE,
  AUTOKEY_ACCESSTOKEN,
  AUTOKEY_CAR_INSURANCE,
} from '../../../utils/helper.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext.js';
import SubmitButton from '../shared/SubmitButton.jsx';
import './whitelabel.css';
import { useTheme } from '../../../contexts/ThemeContext.js';
import {
  getDefaultLanguageFromData,
  validatePortuguesePlate,
} from '../../../utils/functions.js';
import { errorMessages } from '../../../utils/constants.js';
import ReactInputMask from 'react-input-mask';
import Loading from '../shared/Loading.jsx';
import HabitTag from './HabitTag.jsx';
import LanguageSelector from './LanguageSelector.jsx';
import { events as GAevents } from '../../../analytics';
import { getCarInsuranceConfig } from '../../../api/requests/customActions.js';

const Banner = () => {
  const navigate = useNavigate();
  const { fingerprint } = useAuth();
  const access_token = getItemLocalStorage(AUTOKEY_ACCESSTOKEN);
  const userType = getItemLocalStorage(AUTOKEY_TYPE);
  const [dataSharingConsent, setDataSharingConsent] = useState(false);
  const [registrationNumber, setRegistrationNumber] = useState('');
  const [overrideRegistration, setOverrideRegistration] = useState(false);
  const [plateError, setPlateError] = useState(null);
  const [displayCarInsurance, setDisplayCarInsurance] = useState(false);
  const [carInsurance, setCarInsurance] = useState('nao');
  const [isLoading, setIsLoading] = useState(false);
  const { theme } = useTheme();
  const { CONFIG } = theme;
  const { PROXY_PATH } = CONFIG;

  const defaultLanguage = getDefaultLanguageFromData(theme);
  const { image_desktop, image_mobile, title, subtitle, description } =
    theme.bio_sections.bio_header;

  const { card_title, input_label, simulate_button } =
    theme.bio_sections.bio_header_card;

  const bannerStyle = {
    backgroundImage: `url(${theme.images[image_desktop]})`,
  };

  const bannerMobileStyle = {
    backgroundImage: `url(${theme.images[image_mobile]})`,
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    GAevents.subimitBioForm();
    if (displayCarInsurance && userType !== 'guest')
      setItemLocalStorage(AUTOKEY_CAR_INSURANCE, carInsurance);

    if (
      !overrideRegistration &&
      (registrationNumber === '' || registrationNumber.includes('_'))
    )
      return;

    if (!overrideRegistration && registrationNumber) {
      const result = validatePortuguesePlate(registrationNumber);
      if (!result.valid) {
        setPlateError(errorMessages[`error_message_${result.reason}`]);
        return;
      }
    }

    const destination =
      overrideRegistration || !registrationNumber
        ? '/simulation-form'
        : `/simulation-form?registration=${encodeURIComponent(registrationNumber)}`;
    navigate(destination);
  };

  useEffect(() => {
    if (userType === 'guest' || userType === 'user') return;

    const getAndSetInsuranceConfig = async () => {
      setIsLoading(true);
      try {
        const carInsuranceConfig = await getCarInsuranceConfig({
          proxyPath: PROXY_PATH,
          fingerprint,
          flow: userType,
          access_token,
        });
        if (carInsuranceConfig.code === 'error') throw carInsuranceConfig.error;
        const { enable = false, data = 'desabilitado' } =
          carInsuranceConfig.data?.custom_data;
        setDisplayCarInsurance(enable);
        setCarInsurance(enable ? data : 'desabilitado');
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    getAndSetInsuranceConfig();
  }, [PROXY_PATH, access_token, fingerprint, userType]);

  return (
    <>
      <Loading
        isLoading={isLoading}
        dotColor={theme.colors['--color-primary']}
      />
      {/* absolute positioned */}
      <LanguageSelector />
      {theme.habit_tag && <HabitTag />}
      {/* mobile Banner */}
      <div
        className="d-flex flex-column align-items-center d-md-none banner-container-mobile"
        style={bannerMobileStyle}
      >
        <p className="banner-title-mobile">
          {theme.bio_sections.texts[title][defaultLanguage]}
        </p>
        <p className="banner-second-title-mobile">
          {theme.bio_sections.texts[subtitle][defaultLanguage]}
        </p>
        <div className="banner-card-mobile d-flex flex-column">
          <p className="align-self-center banner-card-title">
            {theme.bio_sections.texts[card_title][defaultLanguage]}
          </p>
          <form
            className="d-flex flex-column flex-grow-1"
            onSubmit={handleSubmit}
            action=""
          >
            <label className="banner-input-label">
              {theme.bio_sections.texts[input_label][defaultLanguage]}
            </label>
            <ReactInputMask
              mask="**-**-**"
              className="banner-input"
              placeholder="XX-XX-XX"
              value={overrideRegistration ? '' : registrationNumber}
              disabled={overrideRegistration}
              onChange={(e) => {
                const upper = e.target.value.toUpperCase();
                setRegistrationNumber(upper);
                const isComplete = upper !== '' && !upper.includes('_');
                if (isComplete) {
                  const result = validatePortuguesePlate(upper);
                  setPlateError(
                    result.valid
                      ? null
                      : errorMessages[`error_message_${result.reason}`],
                  );
                } else {
                  setPlateError(null);
                }
              }}
            />
            {!overrideRegistration && plateError && (
              <label className="error-color">{plateError}</label>
            )}
            <div className="d-flex align-items-top justify-content-between mt-2">
              <input
                type="checkbox"
                name="overrideRegistration"
                checked={overrideRegistration}
                onChange={() => {
                  setOverrideRegistration(!overrideRegistration);
                  setPlateError(null);
                }}
                className="align-self-start banner-checkbox me-2 flex-shrink-0"
              />
              <label
                htmlFor="overrideRegistration"
                className="banner-checkbox-label me-auto"
                onClick={() => setOverrideRegistration(!overrideRegistration)}
              >
                Não tenho matrícula
              </label>
            </div>
            {userType === 'lead' && (
              <div className="d-flex align-items-top justify-content-between">
                <input
                  type="checkbox"
                  name="dataSharingConsent"
                  checked={dataSharingConsent}
                  onChange={() => setDataSharingConsent(!dataSharingConsent)}
                  className="align-self-start banner-checkbox me-2 flex-shrink-0"
                />
                <label
                  htmlFor="dataSharingConsent"
                  className="banner-checkbox-label me-auto"
                  onClick={() => setDataSharingConsent(!dataSharingConsent)}
                >
                  Tenho o consentimento do cliente para angariação de dados
                </label>
              </div>
            )}
            {(userType === 'lead' || userType === 'seller') &&
              displayCarInsurance && (
                <div className="d-flex align-items-top justify-content-between">
                  <input
                    type="checkbox"
                    name="carInsurance"
                    id="carInsurance"
                    checked={carInsurance === 'sim'}
                    onChange={(e) =>
                      setCarInsurance(e.target.checked ? 'sim' : 'nao')
                    }
                    className="align-self-start banner-checkbox me-2 flex-shrink-0"
                  />
                  <label
                    htmlFor="carInsurance"
                    className="banner-checkbox-label me-auto"
                    onClick={() =>
                      setCarInsurance(carInsurance === 'nao' ? 'sim' : 'nao')
                    }
                  >
                    Estou a vender o carro no stand
                  </label>
                </div>
              )}
            <SubmitButton
              customClassName={'btn mt-auto align-self-center w-100'}
              isDisabled={
                (userType === 'lead' && !dataSharingConsent) ||
                (!overrideRegistration &&
                  (registrationNumber === '' ||
                    registrationNumber.includes('_'))) ||
                (!overrideRegistration && Boolean(plateError))
              }
              text={theme.bio_sections.texts[simulate_button][defaultLanguage]}
            />
          </form>
        </div>
      </div>
      {/* PC Banner */}
      <div
        className="d-none d-md-flex justify-content-between banner-container"
        style={bannerStyle}
      >
        <div className="d-flex flex-column justify-content-between banner-text-container">
          <div className="d-flex flex-column justify-content-between p-0">
            <p className="banner-title m-0 p-0 mb-2">
              {theme.bio_sections.texts[title][defaultLanguage]}
            </p>
            <p
              className="banner-second-title m-0"
              style={{ fontSize: userType === 'lead' ? '30px' : '45px' }}
            >
              {theme.bio_sections.texts[subtitle][defaultLanguage]}
            </p>
          </div>
          <p className="banner-description mt-auto mb-0 pb-0">
            {theme.bio_sections.texts[description][defaultLanguage]}
          </p>
        </div>
        <div className="banner-card d-flex flex-column">
          <p className="align-self-center banner-card-title">
            {theme.bio_sections.texts[card_title][defaultLanguage]}
          </p>
          <form
            className="d-flex flex-column flex-grow-1"
            onSubmit={handleSubmit}
            action=""
          >
            <label className="banner-input-label">
              {theme.bio_sections.texts[input_label][defaultLanguage]}
            </label>
            <ReactInputMask
              mask="**-**-**"
              className="banner-input"
              placeholder="XX-XX-XX"
              value={overrideRegistration ? '' : registrationNumber}
              disabled={overrideRegistration}
              onChange={(e) => {
                const upper = e.target.value.toUpperCase();
                setRegistrationNumber(upper);
                const isComplete = upper !== '' && !upper.includes('_');
                if (isComplete) {
                  const result = validatePortuguesePlate(upper);
                  setPlateError(
                    result.valid
                      ? null
                      : errorMessages[`error_message_${result.reason}`],
                  );
                } else {
                  setPlateError(null);
                }
              }}
            />
            {!overrideRegistration && plateError && (
              <label className="error-color">{plateError}</label>
            )}
            <div className="d-flex align-items-top justify-content-between mt-3">
              <input
                type="checkbox"
                name="overrideRegistration"
                checked={overrideRegistration}
                onChange={() => {
                  setOverrideRegistration(!overrideRegistration);
                  setPlateError(null);
                }}
                className="align-self-start banner-checkbox me-2 flex-shrink-0"
              />
              <label
                htmlFor="overrideRegistration"
                className="banner-checkbox-label me-auto"
                onClick={() => setOverrideRegistration(!overrideRegistration)}
              >
                Não tenho matrícula
              </label>
            </div>
            {userType === 'lead' && (
              <div className="d-flex align-items-top justify-content-between">
                <input
                  type="checkbox"
                  name="dataSharingConsent"
                  checked={dataSharingConsent}
                  onChange={() => setDataSharingConsent(!dataSharingConsent)}
                  className="align-self-start banner-checkbox me-2 flex-shrink-0"
                />
                <label
                  htmlFor="dataSharingConsent"
                  className="banner-checkbox-label me-auto"
                  onClick={() => setDataSharingConsent(!dataSharingConsent)}
                >
                  Tenho o consentimento do cliente para angariação de dados
                </label>
              </div>
            )}
            {(userType === 'lead' || userType === 'seller') &&
              displayCarInsurance && (
                <div className="d-flex align-items-top justify-content-between">
                  <input
                    type="checkbox"
                    name="carInsurance"
                    checked={carInsurance === 'sim'}
                    onChange={(e) =>
                      setCarInsurance(e.target.checked ? 'sim' : 'nao')
                    }
                    className="align-self-start banner-checkbox me-2 flex-shrink-0"
                  />
                  <label
                    htmlFor="carInsurance"
                    className="banner-checkbox-label me-auto"
                    onClick={() =>
                      setCarInsurance(carInsurance === 'nao' ? 'sim' : 'nao')
                    }
                  >
                    Estou a vender o carro no stand
                  </label>
                </div>
              )}
            <SubmitButton
              customClassName={'mt-auto align-self-center w-100'}
              isDisabled={
                (userType === 'lead' && !dataSharingConsent) ||
                (!overrideRegistration &&
                  (registrationNumber === '' ||
                    registrationNumber.includes('_'))) ||
                (!overrideRegistration && Boolean(plateError))
              }
              text={theme.bio_sections.texts[simulate_button][defaultLanguage]}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default Banner;
